module.exports = __webpack_public_path__ + "static/jakob-red-72d68276253a23862c693b440682feb4.jpg";